//import NotFoundData from "components/NotFoundData";
import styled from "@emotion/styled";
import { Button, Row, Select } from "antd";
import { useAppDispatch, useAppSelector } from "store";
import { setLoading } from "store/slices/loadingSlice";
import NotFoundData from "components/NotFoundData";
import { Dispatch, FC, SetStateAction, useEffect } from "react";
import { GetDataOrderListData } from "services/interface";
import { useGetBankAllList } from "hooks/useFactory";
import OrderTableList from "./OrderTableList";
import SearchOrderForm from "../OrderTabsCard/SearchOrderForm";
const { Option } = Select;

interface OrderCancelProps {
  data: GetDataOrderListData | undefined;
  isLoading: boolean;
  refetch: () => void;
  setSearchInput: Dispatch<SetStateAction<string>>;
  searchInput: string;
  IsHiddenPersonInfo?: boolean;
  setDateInput: Dispatch<SetStateAction<string>>;
  dateInput: string;
  setOpenForm?: Dispatch<SetStateAction<boolean>>;
}

const OrderCancel: FC<OrderCancelProps> = ({
  data,
  isLoading,
  refetch,
  setSearchInput,
  searchInput,
  IsHiddenPersonInfo,
  setDateInput,
  dateInput,
  setOpenForm
}) => {
  const dispatch = useAppDispatch();
  const factory_id = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );
  const childrenBank: React.ReactNode[] = [];
  const { contact } = useAppSelector((state) => state.auth);
  const userContactData = useAppSelector((state) => state.auth.contact);

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  }, [dispatch, isLoading]);

  const refetchData = () => {
    refetch();
  };

  return (
    <>
      <WrapperAll>
        <HeadWrapper>
          <SearchOrderForm
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
          />
          {setOpenForm && contact?.code === "lunganek" && (
            <Button type="primary" onClick={() => {
              setOpenForm(true);
            }}>
              เพิ่มคำสั่งซื้อ
            </Button>
          )}
        </HeadWrapper>
        <CardWrapperTable>
          <OrderTableList
            data={data}
            childrenBank={childrenBank}
            refetchData={refetchData}
            IsHiddenPersonInfo={IsHiddenPersonInfo}
            factory_id={userContactData?.id || ''}
          />
        </CardWrapperTable>
      </WrapperAll>
    </>
  );
};

export default OrderCancel;

// const PaginationWrapper = styled(Pagination)`
//   white-space: nowrap;
// `;
const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
  background-color: #efefef;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;
const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;
